import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import RugbyScoreboardApp from './RugbyScoreboardApp';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RugbyScoreboardApp />
  </React.StrictMode>
);

// Register the service worker for PWA functionality
serviceWorkerRegistration.register();

// Optional: measure performance
reportWebVitals();
